import { adminHttpClient } from '../../../commons/adminHttpClient'
export interface ProductClassesInfo {
  id: string
  offer: boolean
  useSameAsPrevious: boolean
  isEdited: boolean
  isNew: boolean
}

export interface RenewalBenefitDesignWizardResponse {
  wizardStatus: number
  productClassesInfo: ProductClassesInfo[]
}

const renewalBenefitDesignWizard = (): Promise<RenewalBenefitDesignWizardResponse> => {
  return adminHttpClient.get('/Benefit/BenefitRenewal/Ichra/RenewalBenefitDesignWizard')
}

export default renewalBenefitDesignWizard
